import { LinkButton, spacing } from '../..';
import { additionalText } from '../Autocomplete/Autocomplete.css';
import { actionMouseDownHandler } from '../Autocomplete/AutocompleteActionOption';
import { Layout } from '../Layout/Layout';

export interface NotFoundElementProps {
  readonly label: string;
  readonly onClick?: () => void;
}

export const NotFound: React.FC<NotFoundElementProps> = ({ label, onClick }) => (
  <Layout
    alignItems="center"
    onClick={onClick}
    paddingBlockEnd={spacing.s16}
    paddingBlockStart={spacing.s24}
    paddingInline={spacing.s24}
    textAlign="left"
    width="100%"
  >
    <LinkButton
      className={additionalText({ hasAction: onClick != null })}
      onClick={onClick}
      onMouseDown={actionMouseDownHandler}
      role="status"
    >
      {label}
    </LinkButton>
  </Layout>
);
